module.exports = __webpack_public_path__ + "img/fiber-guides.aa506472.jpg";